<template>
<div>
  <div class="inner-header ">
    <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
      <a  @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
              <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
              </g>
          </svg>
        </a>
        <a href="javascript:void(0);" class="link-title">New Project</a>
    </nav>
    </div>
     <div class="outer-wrapper">
    <div class="inner-page bg-white animate__animated animate__slideInRight">
  <b-container fluid>
      <div class="row">
          <div class="col-12">
              <div class="card details-card form-card">
                  <div class="card-body p-0">
                      <div class="row">
                          <div class="col-12">
                              <div class="project-image">
                                  <img src="@/assets/project.svg" alt="">
                              </div>
                          </div>
                          <div class="col-12">
                          <b-form @submit.prevent="CreateProject">
                              <b-form-group label="Project Name">
                                  <b-form-input  type="text"  v-model="AddProject.name" placeholder="Project Name" required></b-form-input>
                              </b-form-group>
                                <b-form-group label="URL">
                                  <b-form-input  type="text"  v-model="AddProject.url" required placeholder="URL" ></b-form-input>
                              </b-form-group>
                                <b-form-group label="SMS Mask">
                                  <b-form-input  type="text" v-model="AddProject.sms_mask" required placeholder="Launch" ></b-form-input>
                              </b-form-group>
                              <b-form-group label="RERA" >
                                  <b-form-input  type="text" v-model="AddProject.rera_id" required placeholder="RERA Number" ></b-form-input>    
                              </b-form-group>
                              <b-form-group label="Locality" >
                                  <b-form-select   v-model="AddProject.locality_id" required :options="localityList" ></b-form-select>
                              </b-form-group>
                                  <b-form-group label="Mailer Templet ID">
                                  <b-form-input  type="text"  v-model="AddProject.mailer_template_id" required placeholder="Mailer Templet ID" ></b-form-input>
                              </b-form-group>
                                <b-form-group label="Project ID" v-if="this.roleid === '1'">
                                  <b-form-select   v-model="AddProject.builder_id" required :options="ProjectList" ></b-form-select>
                                  <!-- <b-form-input  type="text"   v-model="AddProject.builder_id" required placeholder="Builder Id" ></b-form-input> -->
                              </b-form-group>
                                <b-form-group label="SMS Text">
                                <b-form-textarea placeholder="Add Text"  v-model="AddProject.sms_text" rows="3" max-rows="6" required ></b-form-textarea>
                                </b-form-group>
                                  <b-form-group class="mt-5">
                              <b-button type="submit" variant="primary" block>Save</b-button>
                                </b-form-group>
                              </b-form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </b-container>
    </div>
     </div>
    </div>
</template>
<script>
import SingleTagInput from "@/components/Forms/SingleTagInput.vue";
export default {
  name: 'AddProject',
  components: {
    SingleTagInput,
  },
  data() {
    return {
      AddProject: {
        name: null,
        url: null,
        sms_mask: null,
        rera_id: null,
        locality_id: null,
        mailer_template_id: null,
        builder_id: null,
        sms_text: null,
        is_active: true
      },
    }
  },
    methods: {
    CreateProject() {
      this.$axios
        .post("buildings/create_project", { building : this.AddProject })
        .then((res) => {
          swal({
            title: "Project Created!",
            icon: "success",
          }).then(this.$router.replace({ name: "Project" }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    }
  },
  computed: {
    roleid(){
      return localStorage.getItem('radiate-crm-role_id')
    },
    localityList() {
      return this.$store.getters.localitiesMaster;
    },
    ProjectList() {
      return this.$store.getters.ProjectsMaster;
    }
  }
}
</script>
<style  scoped>
label {
  letter-spacing: 0.01em;
  font-size: 14px;
  font-weight: 500;
}
.form-control {
  font-size: 14px;
}
</style>